import React, { useMemo } from "react";
import {useGetCountryName} from "@/hooks/useGetCountryName";
import flags from "@/components/icons/flags"



type FlagProps = React.SVGProps<SVGSVGElement> & {
    countryCode: string;
};

export const FlagIcon: React.FC<FlagProps> = ({ countryCode, ...svgProps }) => {

   if(!countryCode) {
       return null;
   }

    // Normalize country code to lowercase (matching your keys)
    const code = countryCode.toLowerCase();

    const FlagComponent = flags[code];

    if (!FlagComponent) {
        // Optionally, render null or fallback (like a placeholder)
        return null;
    }


    return (
        <div className="flex overflow-visible h-full align-middle items-center justify-center">
            <FlagComponent  className={"h-full object-fill"} />
        </div>
    )
};

export default FlagIcon;